import React from 'react'
import Breadcrumb from '../breadCrumb/BreadCrumb'
import ContactOne from '../container/pagesContainer/ContactOne'
import Footer from '../footer/Footer'
import SEO from '../seo/SEO'
import TopNav from '../topNav/TopNav'

function Contact() {
    return (
        <React.Fragment>
            <SEO title="Royality Technologies || Contact Us" />
            <TopNav />
            <Breadcrumb title="Home" content="Contact Us" image="/images/home/about1.jpg" />
            <ContactOne />
            <Footer />
        </React.Fragment>
    )
}

export default Contact